module.exports = __webpack_public_path__ + "img/money.f95fd3c6.webp";